import * as React from "react"
import { cn } from "../../lib/utils"

const DecidrHeader = React.forwardRef<
  HTMLHeadingElement,
  React.HTMLAttributes<HTMLHeadingElement> & {
    as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  }
>(({ className, as: Component = 'h2', ...props }, ref) => {
  const getTextSize = (component: string) => {
    switch (component) {
      case 'h1':
        return 'text-4xl font-bold leading-tight'
      case 'h2':
        return 'text-3xl font-semibold leading-tight'
      case 'h3':
        return 'text-2xl font-semibold leading-snug'
      case 'h4':
        return 'text-xl font-semibold leading-snug'
      case 'h5':
        return 'text-lg font-semibold leading-snug'
      case 'h6':
        return 'text-base font-semibold leading-snug'
      default:
        return 'text-3xl font-semibold leading-tight'
    }
  }

  return (
    <Component
      ref={ref}
      className={cn(
        "font-sans text-on-surface-default",
        getTextSize(Component),
        className
      )}
      {...props}
    />
  )
})
DecidrHeader.displayName = "DecidrHeader"

export { DecidrHeader } 